<script setup lang="ts">
const props = defineProps({
  blok: Object,
});

const localePath = useLocalePath();

const { state } = useAppStore();

const columns = ref([
  {
    id: 1,
    content: props.blok?.traceability,
    image: null,
    width: "w-3/12",
    border: false,
    badge: true,
  },
  {
    id: 2,
    content: props.blok?.living_income,
    image: props.blok?.living_income_image,
    width: "w-5/12",
    border: false,
  },
  {
    id: 8,
    content: props.blok?.gender,
    image: null,
    width: "w-3/12",
    border: false,
  },
  { id: "spacer" },
  {
    id: 6,
    content: props.blok?.pesticides,
    image: null,
    width: "w-4/12",
    border: false,
  },
  {
    id: 3,
    content: props.blok?.child_labor,
    image: null,
    width: "w-4/12",
    border: false,
  },
  { id: "spacer" },
  {
    id: 4,
    content: props.blok?.deforestation,
    image: null,
    width: "w-4/12",
    border: false,
    badge: true,
  },
  {
    id: 5,
    content: props.blok?.agroforestry,
    image: null,
    width: "w-8/12",
    border: false,
  },
]);
</script>

<template>
  <section class="section">
    <UiContainer>
      <div class="bg-chsc-indigo-soft p-20 rounded-[30px] relative max-[641px]:p-10">
        <img
          :src="blok?.character1.filename"
          class="absolute top-[900px] left-0 max-[769px]:hidden"
        />
        <img
          :src="blok?.character2.filename"
          class="absolute bottom-0 -right-26 max-[769px]:hidden"
        />
        <header
          class="mb-20 text-center [&>h2]:font-eb-garamond [&>h2]:text-chsc-yellow [&>h2]:fs-6xl [&>h2]:mb-8 [&>p]:font-londrina-solid [&>p]:text-chsc-indigo-500 [&>p]:fs-2xl"
        >
          <StoryblokRichText :doc="blok?.header" />
        </header>
        <div class="grid"></div>
        <div
          class="flex flex-wrap -m-8 [&>div]:p-8 max-[769px]:[&>div]:p-3 max-[769px]:[&>div]:m-4"
        >
          <template v-for="column in columns" :key="column.id">
            <div
              v-if="column.id !== 'spacer'"
              :class="['w-1/3', 'max-[769px]:w-full max-[769px]:border-none']"
            >
              <div :class="{ 'bg-chsc-yellow rounded-[40px] p-9': column.badge }">
                <h4
                  :class="[
                    'mb-4 font-londrina-solid fs-3xl uppercase leading-[26px]',
                    { 'text-white': column.badge },
                    { 'text-chsc-yellow': !column.badge },
                  ]"
                >
                  {{ useCategoryName(state.categories, column.id as number) }}
                </h4>
                <div
                  class="flex flex-col space-y-4 font-londrina-solid text-chsc-indigo-500 [&>p]:fs-2xl [&>h5]:fs-3xl [&>h4]:fs-4xl"
                >
                  <StoryblokRichText :doc="column.content" />
                </div>
              </div>
            </div>
            <div v-if="column.id === 'spacer'" class="w-1/3 max-[769px]:hidden"></div>
          </template>
        </div>
        <footer class="w-full pt-72 flex justify-center">
          <UButton :to="localePath('/insights')" :label="blok?.more" size="xl" />
        </footer>
        <!-- <div class="mt-20">
          <header class="text-center relative mb-12">
            <h2
              class="relative font-eb-garamond text-white fs-6xl inline-flex bg-chsc-indigo-500 px-9 z-1"
            >
              {{ blok?.insights_title }}
            </h2>
            <div class="w-full h-px bg-white absolute top-1/2 -translate-y-1/2" />
          </header>
          <div
            class="grid grid-cols-4 gap-8 max-[1025px]:grid-cols-3 max-[769px]:grid-cols-2 max-[641px]:grid-cols-1"
          >
            <StoryblokComponent
              v-for="item in blok?.insights"
              :key="item"
              v-editable="item"
              :blok="item"
            />
          </div> 
        </div>-->
      </div>
    </UiContainer>
  </section>
</template>
